/* eslint-disable no-unused-expressions */
import React from 'react';
import moment from 'moment';
import * as momentTimeZone from 'moment-timezone';
import { store } from '../redux/store';
import clientActions from '../redux/module/client/actions';

import fetchUrl from './fetchUrl';
import {
  GetAllPayers,
  GetBillingSettings,
  GetClients,
  GetCurrentPlans,
  GetInsuranceSetting,
  GetPracticeDetails,
  GetPracticeTimeZone,
  GetProgessNoteMetadata,
  GetProviderPlans,
  getTeamMembers,
  GetTherapistProfile,
  LogHipaaAuditEvent,
} from '../graphql/queries';
import Date from '../components/Date/Date';
import {
  getAppsByTeamOwner,
  getAppsUsed,
  getAppsUsedByTeamOwner,
  hasEnterpriseSub,
} from '../containers/Page/Clients/queries';
import { exerciseIcons } from './constants';

const currencyFormatter = require('currency-formatter');

const {
  setClients,
  setTherapist,
  setTimeZone,
  setTeamMember,
  setInsuranceSetting,
  setPracticeDetails,
  setBillingSetting,
} = clientActions;

const timeZones = moment.tz.names();
const tempTimeZone = new Set();
for (const i in timeZones) {
  tempTimeZone.add(timeZones[i]);
}
const timeZoneList = Array.from(tempTimeZone)?.sort();

export const perPageRecords = 20;

export const totalEventsRecords = 1000;

export const getClientName = async clientId => {
  const clients = await getClientsList();
  const client = clients && clients.length ? clients.find(({ id }) => id === clientId) : null;
  return client && client.personalDetail
    ? client.personalDetail.first + ' ' + client.personalDetail.last
    : '';
};

const grantedRoles = {
  CLINICIAN_BASIC: 'Clinician Basic',
  SUPERVISOR: 'Supervisor',
  CLINICIAN_ADMIN: 'Clinician Admin',
  CLINICIAN_FULL_CLIENT: 'Clinician(view all clients)',
  BILLER: 'Biller',
  CLINICIAN_BASIC_BILLING: 'Clinician Basic Billing',
  SCHEDULER: 'Scheduler',
};

export const momentToDate = date => (date ? moment(date).format('YYYY-MM-DD') : '');

export const startDate = moment()
  .subtract('days', 30)
  .format('YYYY-MM-DD');
export const endDate = moment().format('YYYY-MM-DD');
export const startDateTZ = date => {
  return moment(date)
    .utc()
    .format('YYYY-MM-DD[T]00:00:00Z');
};
export const endDateTZ = date => {
  return moment(date)
    .utc()
    .add('2', 'days')
    .format('YYYY-MM-DD[T]23:59:59Z');
};

export const billingTypes = [
  {
    key: 'all',
    text: 'Viewing All Items',
  },
  {
    key: 'Session',
    text: 'All Sessions',
  },
  {
    key: 'UnInvoicedSession',
    text: 'UnInvoiced Sessions',
  },
  {
    key: 'UnpaidInvoice',
    text: 'Unpaid Invoices',
  },
  {
    key: 'ClientInvoice',
    text: 'Paid Invoices',
  },
  {
    key: 'BillingPayment',
    text: 'Client Payment',
  },
  {
    key: 'InsurancePayment',
    text: 'Insurance Payment',
  },
];
export const claimStatus = {
  scrub: 'SCRUB',
  claim_prepared: 'PREPARED',
  claim_created: 'CREATED',
  claim_submitted: 'SUBMITTED',
  claim_received: 'RECEIVED',
  claim_accepted: 'ACCEPTED',
  payment_report: 'PAYMENT REPORT',
  claim_paid: 'PAID',
  claim_rejected: 'REJECTED',
  claim_rejection_radar_signal_status: 'REJECTION RADAR SIGNAL STATUS',
};

const grantedRolesForPlan = roles => {
  const role = false;
  roles && roles.length
    ? roles.map(role => {
        if (
          role === 'CLINICIAN_ADMIN' ||
          role === 'CLINICIAN_BASIC' ||
          role === 'CLINICIAN_FULL_CLIENT'
        ) {
          role = true;
        }
      })
    : [];
  return role;
};

export const getRolesList = list => {
  let temp = '';
  list
    ? list.map((l, i) => {
        temp = temp + grantedRoles[l] + ' ';
        temp = i === list.length - 1 ? temp : temp + ', ';
      })
    : '';
  return temp;
};

export const getRoleName = role => {
  return grantedRoles[role];
};

export const getMemberList = members => {
  const temp = [];
  members && members.length
    ? members.map(member => {
        let bool = false;
        member.grantedRoles && member.grantedRoles.length
          ? member.grantedRoles.map(m => {
              if (m.includes('CLINICIAN')) {
                bool = true;
              }
            })
          : [];
        if (bool) {
          temp.push(member);
        }
      })
    : [];
  return temp;
};

export const getProviderPlans = () => {
  let plans = JSON.parse(localStorage.getItem('providerPlans')) || [];
  if (!plans || !plans.length) {
    fetchUrl.BTPORTAL(GetProviderPlans).then(res => console.log(res));
    localStorage.setItem('providerPlans', JSON.stringify(getProviderPlans));
    plans = getProviderPlans;
  }
  return plans;
};

export const logHipaaAuditEvent = async (event, clientId) => {
  await fetchUrl
    .BTPORTAL(LogHipaaAuditEvent, { event, clientId })
    .then(({ data: { message } }) => message);
};

export const getClient = async clientId => {
  const clients = await getClientsList();
  return clientId && clients && clients.length
    ? clients.find(({ id, username }) => id === clientId || username === clientId)
    : null;
};

export const getFirstClient = async () => {
  const clients = await getClientsList();
  return localStorage.getItem('selectedUser') || (clients && clients.length && clients[0].id);
};

export const start_date = moment()
  .subtract('days', 30)
  .format('YYYY-MM-DD');
export const end_date = moment().format('YYYY-MM-DD');

export const epochToDate = epoch => {
  return moment.utc(parseInt(epoch)).format('MM/DD/YYYY');
};

export const setDate = date => {
  const day = moment(getDateTimeZoneWise(date)).format('DD');
  const month = moment(getDateTimeZoneWise(date)).format('MMM');
  return <Date day={day} month={month} />;
};

export const getClientsList = async () => {
  let clients = store.getState().Client.get('clients') || [];
  if (!clients || !clients.length) {
    window.clients = [];
    await fetchUrl.BTPORTAL(GetClients, '').then(({ data: { getClients } }) => {
      window.clients = getClients;
      store.dispatch(setClients(getClients));
    });
    clients = [...(window.clients || [])];
    delete window.clients;
    return clients;
  }
  return clients;
};
export const getTherapistInfo = async () => {
  let therapist = store.getState().Client.get('therapist') || [];
  if (!(therapist && Object.keys(therapist).length)) {
    window.therapist = [];
    await fetchUrl.BTPORTAL(GetTherapistProfile, '').then(({ data: { getTherapist } }) => {
      window.therapist = getTherapist;
      store.dispatch(setTherapist(getTherapist));
      // localStorage.setItem('therapist', JSON.stringify(getTherapist));
    });
    therapist = { ...window.therapist };
    delete window.therapist;
  }
  return therapist;
};
export const getPracticeTimezone = async () => {
  let timezone = store.getState().Client.get('timezone') || null;
  if (!timezone) {
    window.timezone = null;
    await fetchUrl.BTPORTAL(GetPracticeTimeZone, '').then(({ data: { getPracticeDetails } }) => {
      window.timezone = getPracticeDetails?.timezone;
      store.dispatch(setTimeZone(getPracticeDetails?.timezone));
    });
    timezone = window.timezone;
    delete window.timezone;
  }
  return timezone;
};
export const getTeamMemberList = async memberId => {
  let teamMembers = store.getState().Client.get('teamMembers') || [];
  if (!(teamMembers && teamMembers.length)) {
    window.teamMembers = [];
    await fetchUrl.BTPORTAL(getTeamMembers, '').then(({ data: { listTeamMembers } }) => {
      window.teamMembers = listTeamMembers;
      store.dispatch(setTeamMember(listTeamMembers));
    });
    teamMembers = [...window.teamMembers];
    delete window.teamMembers;
  }
  if (memberId) {
    const member = teamMembers ? teamMembers.find(({ cognitoId }) => cognitoId === memberId) : null;
    return member ? member.firstName + ' ' + member.lastName + ' ' : '';
  }
  /*  const ref= await getPlanRef();
    if(ref.planRef === '3') {
        return teamMembers;
    }else{
        return teamMembers ? teamMembers.filter(({grantedRoles})=>grantedRolesForPlan(grantedRoles)) : []
    } */
  return teamMembers;
};
export const getInsuranceSetting = async () => {
  let insuranceSettings = store.getState().Client.get('insuranceSettings') || {};
  if (!(insuranceSettings && Object.keys(insuranceSettings).length)) {
    window.insuranceSettings = {};
    await fetchUrl.BTPORTAL(GetInsuranceSetting, '').then(({ data: { getInsuranceSetting } }) => {
      window.insuranceSettings = getInsuranceSetting;
      store.dispatch(setInsuranceSetting(getInsuranceSetting));
    });
    insuranceSettings = { ...window.insuranceSettings };
    delete window.insuranceSettings;
    return insuranceSettings;
  }
  return insuranceSettings;
};
export const getBillingSettings = async () => {
  let billingSettings = store.getState().Client.get('billingSettings') || {};
  if (!(billingSettings && Object.keys(billingSettings).length)) {
    window.billingSettings = {};
    await fetchUrl.BTPORTAL(GetBillingSettings, '').then(({ data: { getBillingSettings } }) => {
      window.billingSettings = getBillingSettings;
      store.dispatch(setBillingSetting(getBillingSettings));
    });
    billingSettings = { ...window.billingSettings };
    delete window.billingSettings;
    return billingSettings;
  }
  return billingSettings;
};
export const getPracticeDetails = async () => {
  let practiceDetails = store.getState().Client.get('practiceDetails') || {};
  if (!(practiceDetails && Object.keys(practiceDetails).length)) {
    window.practiceDetails = {};
    await fetchUrl.BTPORTAL(GetPracticeDetails, '').then(({ data: { getPracticeDetails } }) => {
      window.practiceDetails = getPracticeDetails;
      store.dispatch(setPracticeDetails(getPracticeDetails));
    });
    practiceDetails = { ...window.practiceDetails };
    delete window.practiceDetails;
    return practiceDetails;
  }
  return practiceDetails;
};

export const getDateTimeZoneWise = date => {
  const timeZone = store.getState().Client.get('timezone');
  let tz = 'US/Pacific';
  if (timeZone) {
    tz = timeZoneList.find(
      item => momentTimeZone.tz(item).format('z') === timeZone.split(' (')?.[0],
    );
  }
  return moment(date)
    .tz(tz)
    .format('YYYY-MM-DD HH:mm:ss');
};

export const getTimeZoneName = () =>
  store
    .getState()
    .Client.get('timezone')
    ?.split(' (')?.[0] || 'PDT';

export const convertToUTC = date =>
  moment(date)
    .utc()
    .format('YYYY-MM-DD[T]HH:mm:ssZ');

export const getAppsAPI = () => {
  const { defaultApp, apps } = JSON.parse(localStorage.getItem('apps')) || [];
  if (!(apps && Object.keys(apps).length) || !defaultApp) {
    fetchUrl
      .BTPORTAL(getAppsUsed)
      .then(
        ({
          data: {
            getAppsUsed: { defaultApp, apps },
          },
        }) => {
          localStorage.setItem('apps', JSON.stringify({ defaultApp, apps }));
          return { defaultApp, apps };
        },
      )
      .catch(e => console.log(e));
  }
  return { defaultApp, apps };
};
export const getAppsByTeamOwnerAPI = teamOwnerId => {
  const { defaultApp, apps } = JSON.parse(localStorage.getItem('teamOwnerApps')) || [];
  if (!(apps && Object.keys(apps).length) || !defaultApp) {
    fetchUrl
      .BTPORTAL(getAppsUsedByTeamOwner, { teamOwnerId })
      .then(
        ({
          data: {
            getAppsUsedByTeamOwner: { defaultApp, apps },
          },
        }) => {
          localStorage.setItem('teamOwnerApps', JSON.stringify({ defaultApp, apps }));
          return { defaultApp, apps };
        },
      )
      .catch(e => console.log(e));
  }
  return { defaultApp, apps };
};
export const getDefaultAppsAPI = () => {
  const { defaultApp } = JSON.parse(localStorage.getItem('apps')) || [];
  if (!defaultApp) {
    fetchUrl.BTPORTAL(getAppsUsed).then(
      ({
        data: {
          getAppsUsed: { defaultApp, apps },
        },
      }) => {
        localStorage.setItem('apps', JSON.stringify({ defaultApp, apps }));
        return defaultApp;
      },
    );
  }
  return defaultApp;
};

const getPlanRef = async () => {
  let plan = JSON.parse(localStorage.getItem('currentPlan'));
  if (!plan || !Object.keys(plan).length) {
    window.plan = {};
    await fetchUrl.BTPORTAL(GetCurrentPlans, '').then(({ data: { getCurrentPlan } }) => {
      window.plan = getCurrentPlan;
      localStorage.setItem('currentPlan', JSON.stringify(getCurrentPlan));
    });
    plan = { ...window.plan };
    delete window.plan;
  }
  return plan;
};
export const getCurrentPlan = async () => {
  return await getPlanRef();
};

export const isProfessionalFunc = () => {
  return localStorage.getItem('custom:professionalOverride') === 'true';
};

export const isPremiumFunc = () => {
  return localStorage.getItem('custom:premiumOverride') === 'true';
};

export const isOwner = () =>
  localStorage.getItem('custom:teamOwnerId') === localStorage.getItem('cognito:username');

export const getProgressNoteName = keyValue => {
  let progressMetadata = JSON.parse(localStorage.getItem('progressMetadata')) || [];
  if (!progressMetadata || !progressMetadata.length) {
    fetchUrl.BTPORTAL(GetProgessNoteMetadata, '').then(({ data: { getProgessNoteMetadata } }) => {
      localStorage.setItem('progressMetadata', JSON.stringify(getProgessNoteMetadata));
      progressMetadata = getProgessNoteMetadata;
    });
  }
  if (keyValue) {
    const elements = progressMetadata ? progressMetadata.flatMap(({ elements }) => elements) : [];
    const Obj = elements ? elements.find(({ key }) => key === keyValue) : null;
    return Obj ? Obj.name : '';
  }
  return progressMetadata;
};

export const getPayersList = async search => {
  const payersList = window.payersList || [];
  if (!payersList?.length) {
    const {
      data: { getAllPayers },
    } = await fetchUrl.BTPORTAL(GetAllPayers, '', false,false, "cache-first");
    getAllPayers && getAllPayers.length
      ? getAllPayers.map(({ payer_id, names }) => {
          names && names.map(name => payersList.push({ payer_id, name }));
        })
      : [];

    window.payersList = payersList;
  }

  if (search) {
    return (
      payersList && payersList.filter(({ name, id }) => name.includes(search) || id === search)
    );
  }
  return payersList && payersList.slice(0, 20);
};
export const getPayerName = payerId => {
  let { payersList } = window;
  const payer = payersList ? payersList.find(({ payer_id }) => payer_id === payerId) : [];
  return payer ? payer.name : '';
};

export const formatCurrency = (amt, prec) => {
  const amount = amt || 0;
  const formattedAmount = currencyFormatter.format(amount, {
    code: 'USD',
    precision: prec || 0,
  });
  return formattedAmount;
};

export const setEligibleJSON = json => {
  let { payer, subscriber, dependent, billing_provider, claim } = JSON.parse(json);
  payer = {
    ...payer,
    address: {
      ...payer.address,
      zip: payer?.address?.zip?.split('-')?.join(''),
    },
  };
  subscriber = {
    ...subscriber,
    address: {
      ...subscriber.address,
      zip: subscriber?.address?.zip?.split('-')?.join(''),
    },
  };
  dependent = {
    ...dependent,
    address: {
      ...dependent.address,
      zip: dependent?.address?.zip?.split('-')?.join(''),
    },
  };
  billing_provider = {
    ...billing_provider,
    tax_id: billing_provider?.tax_id?.split('-')?.join(''),
  };
  localStorage.setItem(
    'eligibleJSON',
    JSON.stringify({ claim, payer, subscriber, dependent, billing_provider }),
  );
};

export const getEnterprisePlan = () => {
  fetchUrl.SWASTHCOMMONS(hasEnterpriseSub).then(({ data: { hasEnterpriseSubscription } }) => {
    localStorage.setItem('enterprisePlan', hasEnterpriseSubscription.hasEnterpriseSubscription);
  });
};

export function getCloudIDFromImageURL(image, source, type = 'lessons') {
  let path = '';
  if (image) {
    const imagePathSplitted = image.split('/');
    if (imagePathSplitted.length > 0) {
      path = imagePathSplitted[imagePathSplitted.length - 1];
      const n = path.lastIndexOf('.');
      switch (type) {
      }
      path =
        `${source?.toLowerCase()}/${cloudinaryPaths[source?.toLowerCase()]?.[type]}` +
        path.slice(0, n);
    }
  }
  return path;
}

export function getCloudIDFromImageName(image, source, type = 'lessons') {
  let path = '';
  if (image) {
    const n = image.lastIndexOf('.');
    path =
      `${source?.toLowerCase()}/${cloudinaryPaths[source?.toLowerCase()]?.[type]}` +
      image.slice(0, n);
  }
  return path;
}

export const groupName = 'dbt-coach-users';

export const cloudinaryPaths = {
  dbt: {
    exercises: 'png/exercises/',
    lessons: 'png/lessons/',
  },
  cbt: {
    exercises: 'png/exercises/',
    lessons: 'png/lessons/',
  },
  act: {
    exercises: 'exercises/',
    lessons: 'lessons/',
  },
  bodhi: {
    activities: 'activities/',
    lessons: 'lessons/',
    tracks: 'tracks/',
    community: 'community/',
    assessments: 'assessments/',
    tools: 'tools/',
  },
  mi: {
    behavior: 'png/behavior/',
    sessions: 'png/sessions/',
    exercises: 'png/exercises/',
    lessons: 'png/lessons/',
    activities: 'png/activities/',
  },
};

export function removeEmptyData(exerciseData) {
  const modifiedData = [];
  exerciseData?.details &&
    exerciseData.details.forEach(element => {
      if (
        element.type === 'group' ||
        element.type === 'graph' ||
        element.type === 'autoChange' ||
        element.type === 'loop' ||
        element.type === 'assessment'
      ) {
        const group = {
          type: element.type,
          title: element.title,
          icon: element.icon,
          details: [],
        };
        element.details.forEach(detail => {
          // eslint-disable-next-line no-use-before-define
          if (containsValue(detail.value)) {
            group.details.push(detail);
          }
          if (detail.type === 'groupItems') {
            const groupedItems = {
              ...detail,
              details: [],
            };
            detail.details.forEach(groupedItem => {
              if (containsValue(groupedItem.value)) {
                groupedItems.details.push(groupedItem);
              }
            });
            if (groupedItems.details.length) {
              group.details.push(groupedItems);
            }
          }
        });
        if (group.details.length > 0) {
          group.icon = group.icon ? exerciseIcons[group.icon] : undefined;
          modifiedData.push(group);
        }
      } else if (containsValue(element.value)) {
        modifiedData.push({
          ...element,
          // icon: element.icon ? exerciseIcons[element.icon] : undefined,
        });
      }
    });
  return modifiedData;
}

const containsValue = value => {
  if (!value) {
    return false;
  }
  if (value.intValues && value.intValues.length) {
    return true;
  }
  if (value.stringValues && value.stringValues.length) {
    return true;
  }
  if (value.booleanValues && value.booleanValues.length) {
    return true;
  }
  if (value.keyValues && value.keyValues.length) {
    return true;
  }
  return false;
};
export function pluralString(quantity, string, pluralString) {
  if (quantity > 1) {
    return ' ' + (pluralString || string + 's');
  }
  return ' ' + (string === 'minute' ? 'seconds' : string);
}

export function pluralStringWithQuantity(quantity, string, pluralString) {
  if (quantity > 1) {
    return quantity + (pluralString || string + 's');
  }
  return quantity + ' ' + string;
}

export const pastelColors = [
  '#DBFFE5',
  '#DFD8FF',
  '#EAD1EC',
  '#E3E7D4',
  '#CDF0FB',
  '#FFD5C8',
  '#D2FFCF',
  '#EBDBBB',
  '#DCE4E3',
];

export const jsonStr = obj => {
  return obj
    ? JSON.parse(
        obj.replace(/(\w+:)|(\w+ :)/g, function(matchedStr) {
          return '"' + matchedStr.substring(0, matchedStr.length - 1) + '":';
        }),
      )
    : '';
};
export const getParseDetails = details => {
  const temp = typeof details === 'string' ? JSON.parse(details) : details || {};
  return typeof temp === 'string' ? jsonStr(temp) : temp;
};
